import React, { FC } from "react";
import { IconButton, IconTypesKeys } from "@evergis/ui";
import { GeometryType } from "@evergis/api";

import { useFeatureCreator } from "../../../LayerList/hooks/useFeatureCreator";
import { EditGeometryType } from "../../../../evergis/core/attributes/geometryTypes";

export const AddFeatureButton: FC<{
  title?: string;
  icon?: IconTypesKeys;
  layerName?: string;
  geometryType?: GeometryType | EditGeometryType;
}> = ({ title, icon = "feature_add", layerName, geometryType }) => {
  const [, handleAddFeature] = useFeatureCreator(layerName, geometryType);

  return (
    <IconButton kind={icon} primary onClick={handleAddFeature}>
      {title}
    </IconButton>
  );
};
